export const styles = {
  closeIconContainer: {
    display: 'flex',
    width: '36px',
    height: '36px',
    borderLeft: '1px solid #F3F4F9',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
};
